import { render, staticRenderFns } from "./vatInvoiceDetail.vue?vue&type=template&id=52850baa&scoped=true&"
import script from "./vatInvoiceDetail.vue?vue&type=script&lang=js&"
export * from "./vatInvoiceDetail.vue?vue&type=script&lang=js&"
import style0 from "./vatInvoiceDetail.vue?vue&type=style&index=0&id=52850baa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52850baa",
  null
  
)

export default component.exports